import { CapoPlugin } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];